import GenericError from './GenericError.page';

export default GenericError;
